import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import './css/main.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import firebase from 'firebase/app';
import "firebase/analytics";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyBCkv-vUU3UDBDsJFFRMlNWOBQDpObnWkI",
    authDomain: "myportfolio-a0450.firebaseapp.com",
    projectId: "myportfolio-a0450",
    storageBucket: "myportfolio-a0450.appspot.com",
    messagingSenderId: "360004229649",
    appId: "1:360004229649:web:82b15989d15b4169b4afb0",
    measurementId: "G-GGL41JNFVG"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
